<template>
    <div>
        <div v-if="isLoading" class="loading-overlay2">
            <div class="">
                <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#52b2cf" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
                </svg>
            </div>
        </div>      
        <div>
            <div class="form-2-header-section">
                <div class="form-header-div">
                    <div class="div-block-966">
                        <a href="#" class="w-inline-block"><img sizes="(max-width: 2083px) 100vw, 2083px" srcset="@/assets/images/_Rx-Pros-Logo-01-p-500.png 500w, @/assets/images/_Rx-Pros-Logo-01-p-800.png 800w, @/assets/images/_Rx-Pros-Logo-01-p-1080.png 1080w, @/assets/images/_Rx-Pros-Logo-01.png 2083w" alt="" src="@/assets/images/_Rx-Pros-Logo-01.png" loading="lazy" class="image-30"></a>
                    </div>
                </div>
                <div class="div-block-181">
                    <div class="girl-div"></div>
                </div>
            </div>
            
            <div class="form-section _2" >
           
                <div class="questions-div" style="margin-top:-80px;">
                    <!-- Step 1: Do you currently take weight loss medication? -->
                    <div class="question-container _2" v-if="active_el==1">
                        <div class="question-div-2">
                            <div class="text-block-513 hq _2">Do you currently take weight loss medication?<br></div>
                            <div class="felix-form-block w-form">
                                <form>
                                    <div class="div-block-1487">
                                        <a href="#" class="button-68 w-button" @click.prevent="setValue('currentlyTakingGLP','Yes')">YES</a>
                                        <a href="#" class="button-68 w-button" @click.prevent="setValue('currentlyTakingGLP','No')">NO</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
    
                    <!-- Step 2: What weight loss drugs are you currently prescribed? -->
                    <div class="question-container form-rep _2" v-if="active_el==2">
                        <div class="question-div-2">
                            <div class="text-block-513 hq">What weight loss drugs are you currently prescribed?<br></div>
                            <div class="form-subs">Include drugs you have taken in the last 2 weeks only.</div>
                            <div class="felix-form-block form-rep w-form">
                                <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-16">
                                    <div class="program-choice-div products">
                                        <a href="#" class="link-block-48 tirz _2box_leftdiv w-inline-block" @click.prevent="setValue('currentGLPMed','Tirzepatide')">
                                            <div class="div-block-1643 tirz" style="padding-top:25px">
                                                <img loading="lazy" src="" alt="" class="image-360">
                                                <div class="form-product-2">Tirzepatide</div>
                                                <div class="text-block-724">COMPOUND</div>
                                                <!-- The brand names stay on this step. It asks what the customer is
                                                     already prescribed, so they need to recognise their own script.
                                                     The selection step below sells, and only names what we sell. -->
                                                <p class="paragraph-126 report brand-note">Same active ingredient as <strong>Mounjaro® &amp; Zepbound®</strong></p>
                                            </div>
                                        </a>
                                        <a href="#" class="link-block-48 sema _2 w-inline-block" @click.prevent="setValue('currentGLPMed','Semaglutide')">
                                            <div class="div-block-1643 sema" style="padding-top:25px">
                                                <img loading="lazy" src="" alt="" class="image-360">
                                                <div class="form-product-2">Semaglutide</div>
                                                <div class="text-block-724">COMPOUND</div>
                                                <p class="paragraph-126 report brand-note">Same active ingredient as <strong>Ozempic® &amp; Wegovy®</strong></p>
                                            </div>
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="enroll-form-back-link-div">
                            <a href="#" class="enroll-form-back-link w-inline-block" @click.prevent="moveBack()">
                                <div class="enroll-form-back-text">&lt; Go Back</div>
                            </a>
                        </div>
                    </div>
    
                    <!-- Step 3: What dosage are you currently taking? -->
                    <div class="question-container _2" v-if="active_el==3">
                        <div class="question-div-2">
                            <div class="text-block-513 hq _2">What {{planOptions.currentGLPMed}} dosage are you currently taking?</div>
                            <div class="form-subs">❗To be approved for higher dosages, you must upload a clear photo of your current medication or past prescription showing your name and dosage. Without this, our doctors cannot legally prescribe an increased dose, and you must begin at the initial starter dosage schedule❗</div>
                            <div class="felix-form-block w-form">
                                <form @submit.prevent="setPlan()">
                                    <select v-model="planOptions.currentDose" required="" class="select-field-7 form _2 w-select">
                                        <option value="">Select dose...</option>
                                        <option v-for="d in doseOption" :key="d" :value="d">{{d}} mg</option>
                                    </select>
                                    <input type="submit" data-wait="Please wait..." class="form-button w-button" value="Next ->">
                                </form>
                            </div>
                            
                        </div>
                        <div class="enroll-form-back-link-div">
                            <a href="#" class="enroll-form-back-link w-inline-block" @click.prevent="moveBack()">
                                <div class="enroll-form-back-text">&lt; Go Back</div>
                            </a>
                        </div>
                    </div>
    
                    <!-- Step 4: Choose your medication -->
                    <div class="question-container form-rep _2" v-if="active_el==4">
                        <div class="question-div-2">
                            <div class="text-block-513 hq">Choose your medication:<br></div>
                            
                            <div class="felix-form-block form-rep w-form">
                                <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-16">
                                    <div class="program-choice-div products showCenter">
                                        <a href="#" class="link-block-48 tirz _2box_leftdiv w-inline-block" @click.prevent="setValue('selectedGLPMed','Tirzepatide')">
                                            <div class="div-block-1643 tirz" style="position: relative;">
                                                <img src="/images/klarna-badge.webp" alt="Klarna" class="klarna-badge">
                                                <div class="text-block-719"><span class="text-span-174 tirz">Most Effective</span></div>
                                                <div class="form-product-2">Tirzepatide</div>
                                                <div class="text-block-724">Compounded with B6 <br/>(Pyridoxine)</div>
                                                <p class="paragraph-126 report"></p>
                                                <div class="div-block-1949">
                                                    <div>
                                                        <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                            <div class="bullet-text-3 _2"><strong>Up to 22%&nbsp;</strong>Weight Loss*</div>
                                                        </div>
                                                        <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                            <div class="bullet-text-3 _2">Works on <strong>2</strong> GLP Receptors.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                                    <div class="text-block-713">A once-weekly injection.</div>
                                                </div>
                                                <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                                    <div class="text-block-713">Most Effective GLP-1</div>
                                                </div>
                                                <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                                    <div class="text-block-713">Produced in the USA.</div>
                                                </div>
                                                <div class="text-block-1140" style="margin-bottom: 1px;">All Dosages Same Price</div>
                                                <div class="text-block-1140" style="font-weight: normal;">2.5mg | 5mg | 7.5mg | 10mg | 12.5mg | 15mg</div>
                                                <div class="text-block-1140">Starting at ${{ tirzStartPrice }} for month 1</div><input type="submit" data-wait="Please wait..." class="submit-button-7 w-button" value="Get Started">
                                            </div>
                                        </a>
                                        <a href="#" class="link-block-48 sema _2 w-inline-block" @click.prevent="setValue('selectedGLPMed','Semaglutide')">
                                            <div class="div-block-1643 sema" style="position: relative;">
                                                <img src="/images/klarna-badge.webp" alt="Klarna" class="klarna-badge">
                                                <div class="text-block-719"><span class="text-span-174 sema">Most Popular</span></div>
                                                <div class="form-product-2">Semaglutide</div>
                                                <div class="text-block-724">Compounded with B12 <br/>(Cyanocobalamin)</div>
                                                <p class="paragraph-126 report"></p>
                                                <div class="div-block-1949">
                                                    <div>
                                                        <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                            <div class="bullet-text-3"><strong>Up to 16%</strong> Weight Loss</div>
                                                        </div>
                                                        <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                            <div class="bullet-text-3">Works on <strong>1 </strong>GLP Receptor</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                                    <div class="text-block-713">A once-weekly injection.</div>
                                                </div>
                                                <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                                    <div class="text-block-713">Most Prescribed GLP-1 </div>
                                                </div>
                                                <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                                    <div class="text-block-713">Produced in the USA.</div>
                                                </div>
                                                <div class="text-block-1140" style="margin-bottom: 1px;">All Dosages Same Price</div>
                                                <div class="text-block-1140" style="font-weight: normal;">0.5mg | 1mg | 1.75mg | 2.5mg <br/>&#8203;</div>
                                                
                                                <div class="text-block-1140">Starting at ${{ semaStartPrice }} for month 1</div><input type="submit" data-wait="Please wait..." class="submit-button-7 w-button" value="Get Started">
                                            </div>
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="enroll-form-back-link-div">
                            <a href="#" class="enroll-form-back-link w-inline-block" @click.prevent="moveBack()">
                                <div class="enroll-form-back-text">&lt; Go Back</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:280px"></div>
    </div>
    </template>
    
    <script>
    import {
        mapActions,
        mapGetters
    } from 'vuex';
    import {
        getProductById
    } from '@/utils/productData';

    // Backend product ObjectIds — the same ids moveToCheckout carts, so the "starting at"
    // price is fetched for the exact product the Get Started button adds.
    const MED_PRODUCT_IDS = {
        Tirzepatide: '675ac4cb6bf102c19ec3afe9',
        Semaglutide: '675ac4cb6bf102c19ec3afec'
    };
    // The cards quote the lowest per-month rate, which is the 12-month plan total
    // divided over its term.
    const LOWEST_PRICE_TERMS = 12;
    // 12-month plan totals, shown only if /api/get-all-plans has no 12-month promo plan
    // so the card never blanks. These are the live non-promo totals for each product.
    const TERM_TOTAL_FALLBACK = {
        Tirzepatide: 1739.64,
        Semaglutide: 1199.88
    };

    export default {
        data() {
            return {
                lastStrp: 0,
                baseUrl: process.env.VUE_APP_API_ENDPOINT,
                // Live 12-month promo plan total per med from /api/get-all-plans.
                // null until loadStartingPrices resolves; on a miss the card falls back
                // to TERM_TOTAL_FALLBACK so the display never fabricates a price.
                promoTermTotal: {
                    Tirzepatide: null,
                    Semaglutide: null
                },
                showMessage: false,
                active_el: 1,
                isLoading: false,
                planOptions: {
                    currentlyTakingGLP: '',
                    currentGLPMed: '',
                    selectedGLPMed: '',
                    selectedPlanTerms: '',
                    currentDose: ''
                },
                trackedEvents: {}
            }
        },
        async mounted() {
            await this.loadStartingPrices();
        },
        computed: {
            ...mapGetters(['user']),
            tirzStartPrice() {
                return this.startPriceFor('Tirzepatide');
            },
            semaStartPrice() {
                return this.startPriceFor('Semaglutide');
            },
            doseOption() {
                if (this.planOptions.currentGLPMed === 'Semaglutide') {
                    return [0.25, 0.5, 1, 2, 2.5];
                }
                return [2.5, 5, 7.5, 10, 12.5, 15];
            },
            bmi() {
                const heightInInches = parseFloat(this.user.height_inch);
                const weightInPounds = parseFloat(this.user.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            }
        },
        watch: {
            active_el() {
                window.scrollTo(0, 0)
            }
        },
        methods: {
            ...mapActions([
                'setCartVisibility',
                'clearCart'
            ]),
            // Lowest per-month rate for a med — the 12-month total spread over its term.
            startPriceFor(med) {
                const total = this.promoTermTotal[med] != null ?
                    this.promoTermTotal[med] :
                    TERM_TOTAL_FALLBACK[med];
                return (total / LOWEST_PRICE_TERMS).toFixed(2);
            },
            // Fetch the live 12-month promo plan for both meds so the cards quote the same
            // price the checkout charges instead of a hardcoded number.
            async loadStartingPrices() {
                await Promise.all(Object.keys(MED_PRODUCT_IDS).map(async (med) => {
                    try {
                        const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`, {
                            params: { isPromo: true, productId: MED_PRODUCT_IDS[med] }
                        });
                        if (response.data.status === 'success' && Array.isArray(response.data.plans)) {
                            const longest = response.data.plans.find((plan) => plan && Number(plan.terms) === LOWEST_PRICE_TERMS && plan.price != null);
                            if (longest) this.promoTermTotal[med] = Number(longest.price);
                        }
                    } catch (error) {
                        console.error(`Error loading starting price for ${med}:`, error);
                    }
                }));
            },
            scrolltoTop() {
                setTimeout(function () {
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 100);
            },
            selectedYes() {
                this.showMessage = false;
                this.planOptions.selectedGLPMed = this.planOptions.currentGLPMed;
                this.moveToCheckout();
            },
            setPlan() {
                if (this.planOptions.currentDose == null) {
                    return false;
                }
                try {
                    if (window.tracking && this.planOptions.currentGLPMed && this.planOptions.currentDose && !this.trackedEvents['medication_dose']) {
                        window.tracking.event('medication_dose', { funnel_step: 8, form: 'home', medication: this.planOptions.currentGLPMed, dose: this.planOptions.currentDose });
                        this.trackedEvents['medication_dose'] = true;
                    }
                } catch(e) { console.log('Error recording medication_dose event', e); }
                //calculate BMI
                if (this.bmi < 20) {
                    this.addTagForDisqualify();
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your BMI is less than 20."
                        }
                    });
                    return false;
                } else {
                    this.planOptions.selectedGLPMed = this.planOptions.currentGLPMed;
                    localStorage.setItem('currentMed', JSON.stringify({
                        med: this.planOptions.currentGLPMed,
                        dose: this.planOptions.currentDose
                    }))
                    
                    this.moveNext(1);
                }
            },
            async setValue(field, value) {
                this.lastStrp=0;
                this.planOptions[field] = value;
                
                try {
                    if (window.tracking) {
                        if (field === 'currentlyTakingGLP' && !this.trackedEvents['glp1_status']) {
                            window.tracking.event('glp1_status', { funnel_step: 6, form: 'home', glp1_taking: value === 'Yes' });
                            this.trackedEvents['glp1_status'] = true;
                        } else if (field === 'currentGLPMed' && !this.trackedEvents['prior_medications']) {
                            window.tracking.event('prior_medications', { funnel_step: 7, form: 'home', medication: value });
                            this.trackedEvents['prior_medications'] = true;
                        } else if (field === 'selectedGLPMed' && !this.trackedEvents['treatment_selection']) {
                            window.tracking.event('treatment_selection', { funnel_step: 9, form: 'home', medication: value });
                            this.trackedEvents['treatment_selection'] = true;
                        }
                    }
                } catch(e) { console.log('Error recording selection events', e); }

                if (field === 'currentlyTakingGLP' && value === 'No') {
                    this.lastStrp=1;
                    if (this.bmi < 20) {
                        this.addTagForDisqualify();
                        this.$router.push({
                            name: 'leadDisqualified',
                            query: {
                                message: "Based on your BMI, you don't currently qualify for this treatment.."
                            }
                        });
                        return false;
                    }
                    this.moveNext(3);
                } else if (field === 'selectedGLPMed') {
                    this.moveToCheckout();
                } else {
                    this.moveNext(1);
                }
            },
            addTagForDisqualify() {
                this.$axios.get(`${this.baseUrl}/forms/add-disqualify`);
            },
            moveToSorryPage() {
                this.$router.push("/sorry?message=We're truly sorry to see you go. We'll notify you as soon as the doses are available.")
            },
            async moveToCheckout() {
                this.isLoading = true;

                await this.clearCart();

                // Product IDs for Tirzepatide and Semaglutide
                let productId = this.planOptions.selectedGLPMed === 'Tirzepatide' ?
                    '675ac4cb6bf102c19ec3afe9' :
                    '675ac4cb6bf102c19ec3afec';

                try {
                    let product = getProductById(productId);
                    let plan = product[0];

                    const cartItem = {
                        id: plan.id,
                        name: plan.name,
                        category: plan.category.primary,
                        price: plan.pricing.retail_price,
                        retail_price: plan.pricing.retail_price,
                        subheader: 'Compound Medication',
                        sku: plan.sku,
                        stripe_id: plan.stripe_id,
                        quantity: 1,
                        image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${plan.image_pre_text}/1.webp`,
                        is_addon: false,
                    };

                    // Track add to cart event is removed, fires at checkout


                    await this.saveCart(cartItem);
                } catch (error) {
                    console.error('Error creating cart:', error);
                    this.showError('Error adding item to cart. Please try again.');
                    this.isLoading = false;
                }
            },
            saveCart(cartItem) {
                this.isLoading = true;
                let postData = {
                    ...cartItem,
                    sema_offer: this.$store.getters.offerSema,
                    tir_offer: this.$store.getters.offerTir,
                    currentGLPMed: this.planOptions.currentGLPMed,
                    currentDose: this.planOptions.currentDose,
                    is_addon: false
                };
    
                this.$axios.post(`${this.baseUrl}/api/save-cart`, postData, {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(response => {
                        if (response.data.status === 'success') {
                            this.$store.dispatch('addToCart', cartItem);
                            this.setCartVisibility(false);
                            this.$router.push({
                                name: 'checkoutWeightLoss',
                                params: {
                                    cart_id: response.data.id
                                }
                            });
                            this.isLoading = false;
                            
                        } else {
                            alert("Unexpected response:", response.data);
                        }
                    })
                    .catch(error => {
                        alert("Error saving cart:", error.message);
                    });
            },
            moveNext(step) {
                this.active_el = this.active_el + step;
            },
            moveBack() {
                if(this.lastStrp==1){
                   this.active_el = 1
                }else if (this.active_el > 1) {
                    this.active_el = this.active_el - 1;
                }
            }
        }
    }
    </script>
    <style>
    .hidedesk{
        display: none;
    }
    .klarna-badge {
        position: absolute;
        top: 2px;
        right: -6px;
        width: 46px;
        height: auto;
        z-index: 2;
    }
    .link-block-48.tirz._2box_leftdiv,
    .link-block-48.sema._2 {
        background-position: 90% 16%;
    }
    /* The vial art ships as WebP now. The webflow export still points these two
       cards at the PNG copies and that file is replaced on every export, so the
       swap lives here instead. Both selectors carry three classes, which outranks
       the export's rules at every breakpoint. */
    .link-block-48.tirz._2box_leftdiv {
        background-image: url('~@/assets/images/RxPros_TirzepVial_1.webp');
    }
    .link-block-48.sema._2 {
        background-image: url('~@/assets/images/RxPros_SemaVial_1.webp');
    }
    @media screen and (max-width: 479px) {
    /* The vial art sits at 90% across the card, and the webflow export widens
       this caption to 100% below 480px, so the whole sentence fitted on one
       line and ran straight through the bottle. Breaking before the brand
       names is the wrap desktop already does on its own. The class is on the
       two captions that carry a <strong>; the empty ones on the selection
       step below have none, so this rule cannot reach them. */
    .brand-note strong {
        display: block;
    }
    .hidedesk{
        display: block;
    }
    .klarna-badge {
        width: 48px;
        top: 2px;
        right: -4px;
    }
}
</style>
    